require('../modules/es7.global');
module.exports = require('../modules/_core').global;



// WEBPACK FOOTER //
// ./~/@babel/polyfill/~/core-js/library/fn/global.js